import { useState, memo, useEffect, useMemo } from 'react';
import { getGlobalStore } from '@/store/global';
import { getQaStore } from '@/store/qa';
import './index.scss';
import classNames from 'classnames';

const WarningModal = () => {
    const [tips, setTips] = useState('');
    const handleClose = () => setTips('');

    const handleGoRecharge = () => {
        const { lucaId, projectId } = getQaStore()!.qaConfig;
        getGlobalStore()?.publish('RightsModal', { type: 'open', params: { lucaId, projectId } });
    };

    useEffect(() => {
        getGlobalStore()?.subscribe('WarningModal', (params: { type: string; content: string }) => {
            switch (params.type) {
                case 'normal':
                    setTips(params.content);
                    break;
                case 'recharge':
                    setTips('recharge');
                    break;
                case 'no_view_permission':
                    setTips('no_view_permission');
                    break;
                default:
                    handleClose();
                    break;
            }
        });
    }, []);

    const renderModal = useMemo(() => {
        switch (tips) {
            case '':
                return null;
            case 'no_view_permission':
                return (
                    <div className={classNames('recharge-tip-modal', 'view-tip-modal')}>
                        <div className="recharge-tip-modal__close" onClick={handleClose} />
                        <div className="recharge-tip-modal__content" dangerouslySetInnerHTML={{ __html: '暂无查看权限\n请先购课' }} />
                        <div className="recharge-tip-modal__btn" onClick={handleClose}>
                            我知道了
                        </div>
                    </div>
                );
            case 'recharge':
                return (
                    <div className="recharge-tip-modal">
                        <div className="recharge-tip-modal__close" onClick={handleClose} />
                        <div className="recharge-tip-modal__content" dangerouslySetInnerHTML={{ __html: '暂无名师答疑权限\n请先购买' }} />
                        <div className="recharge-tip-modal__btn" onClick={handleGoRecharge}>
                            去购买
                        </div>
                    </div>
                );
            default:
                return (
                    <div className="warning-modal">
                        <div className="warning-modal__tips">{tips}</div>
                        <div className="warning-modal__close" onClick={handleClose}>
                            我知道了
                        </div>
                    </div>
                );
        }
    }, [tips]);

    return (
        <div className="warning-modal-overlay" style={{ display: tips ? 'flex' : 'none' }}>
            {renderModal}
        </div>
    );
};

export default memo(WarningModal);
